// Video player configuration constants
export const PRELOAD_TIME_SECONDS = 2.0;
export const TRANSITION_THRESHOLD = 0.1; // Switch 100ms before end
export const IMMEDIATE_TRANSITION_THRESHOLD = 0.05; // 50ms threshold for immediate switch
export const SKIP_FEEDBACK_DURATION = 2000; // 2 seconds
export const PLAY_DELAY = 100; // 100ms delay for play after scrub
export const SKIP_SECONDS = 5; // 5 seconds for arrow key skips
